import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';
import { borders, paddings, radius } from 'src/styles/Themes/Metrics';
import { Transition } from '@/styles/Themes/KeyFrames';

export const ViewMoreDesktop = styled.div`
    display: none;

    ${Screen.desktop} {
        display: flex;
        position: relative;
        width: 100%;
        background-color: ${cssVars.bg_sand_dark3};
        border-radius: ${radius.small};
        max-height: 120px;
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 50%;
    padding: 5px 10px 5px 80px;
`;

export const SelectedTitle = styled.div`
    display: flex;
    align-items: center;
    color: ${cssVars.svg_gray1_white};
    font-size: ${Text.Full.heading3};
    padding: 5px 0;
    width: 80%;
`;

export const SelectedExperience = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    color: ${cssVars.svg_gray2_gray3};
`;

export const Button = styled.a`
    display: block;
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-grow: 1;

    border-radius: ${radius.button};
    padding: ${paddings.medium};
    border: ${borders.small} ${Palette.green.normal};
    color: ${Palette.green.normal};
    background-color: transparent;
    &:hover {
        background-color: ${cssVars.bg_green_dark3};
        color: ${Palette.white.normal};
        box-shadow: ${cssVars.shadow_normal};
        text-decoration: none;
    }

    > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const ButtonWrapper = styled.div`
    width: 100%;

    ${Screen.desktop} {
        padding: 5% 80px 5% 10px;
        float: right;
        vertical-align: middle;
        width: 50%;
        > button {
            background-color: transparent;
            color: ${Palette.green.normal};
            border-color: ${Palette.green.normal};
            &:hover {
                background-color: ${Palette.green.normal};
                color: ${Palette.white.normal};
                cursor: pointer;
                ${Transition.normal};
            }
        }
    }
`;
